import * as React from "react";
import PropTypes from "prop-types";
import { PlayCircleIcon } from "../../themeV2";
import { Influencer } from "../../domain";
import css from "./VideoAvatar.module.css";

const VideoAvatar = React.memo(function VideoAvatar({ influencer }) {
  const videoRef = React.useRef(null);
  const [isPlaying, setIsPlaying] = React.useState(false);

  const handlePlay = React.useCallback(() => {
    videoRef.current?.play();
  }, []);

  React.useEffect(() => {
    const el = videoRef.current;
    if (!el) {
      return;
    }

    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);

    el.addEventListener("play", onPlay);
    el.addEventListener("pause", onPause);

    return () => {
      el.removeEventListener("play", onPlay);
      el.removeEventListener("pause", onPause);
    };
  }, []);

  return (
    <div className={css.wrapper}>
      <video
        ref={videoRef}
        className={css.video}
        loop
        controls={isPlaying}
        src={influencer.videoAvatarUrl}
        aria-label={`${influencer.name} video`}
      />

      {!isPlaying && (
        <div className={css.overlay}>
          <button
            type="button"
            className={css.playButton}
            onClick={handlePlay}
            aria-label="Play video"
            title="Preview Video"
          >
            <PlayCircleIcon />
          </button>
        </div>
      )}
    </div>
  );
});

VideoAvatar.propTypes = {
  influencer: PropTypes.instanceOf(Influencer),
};

export default VideoAvatar;
